// const
export const ENUM_ATE_DEV_ARRAY: string[] = ['f.allegrucci', 'f.tomassoni', 's.pecchia'];

// enum
export enum LOCALSTORAGE {
  FBM_TOKEN = 'ATE.diin.stor.fb_tok',
  FBM_MESSAGES = 'ATE.diin.stor.fb_msg',
}
export enum ENUM_SYS_IMPOSTAZIONI {
  CLIENTNG = 'ClientNg',
  CLIENTNG_CustomCode = 'CustomCode',
  // rimosso in vers db 3.1.2 CLIENTNG_CustomLogo = 'CustomLogo',
  CLIENTNG_UploadVirtualPathAttachments = 'UploadVirtualPathAttachments',
  CLIENTNG_UploadVirtualPathApplication = 'UploadVirtualPathApplication',
  CLIENTNG_PaginatorItemsPerPage = 'PaginatorItemsPerPage',
  CLIENTNG_DatesRangeDays_ProceduraDati = 'DatesRangeDays_ProceduraDati',
  CLIENTNG_DatesRangeDays = 'DatesRangeDays',
  // base per la versione db
  BASE_VersioneDb = 'VersioneDb',
}
export enum ENUM_CUSTOMER_CODES {
  TARKETT = '136dfe9f-d055-488a-bc54-dedb2cc863f2',
}

export enum ENUM_ATE_ROLES {
  USER = 'USER',
  ADMIN = 'ADMIN',
  CONNECT_DATA = 'CONNECT_DATA',
}

export enum ENUM_SERVER_CODE {
  LOGIN_PASSRESTORE = 'PASSRESTORE',
  LOGIN_PASSCHANGE = 'PASSCHANGE',
  LOGIN_NO_USER = 'NO_USER',
  LOGIN_NO_LICENSE = 'NO_LICENSE',
  LOGIN_NO_ABP = 'NO_ABP',
  CLIENT_MSG = 'CLIENT_MSG',
}

export enum ENUM_TAG_CODTAB {
  Macchina = 'MAC',
  Postazione = 'POS',
  Componente = 'COM',
  Reparto = 'REP',
}
export enum ENUM_ESITI_TIPO {
  OK = 1,
  POK = 2,
  KO = 0,
}
export enum ENUM_INPUT_TIPO {
  BTN = 1,
  TXT = 2,
  NUM = 3,
  QRC = 4,
  FTO = 5,
  LST = 6
}
export enum ENUM_AZIONI_CODICE {
  POPUP = 1,
  TEXT = 2,
  PHOTO = 3,
  EMAIL = 4,
  NOTIFY = 5,
  GOTO_PRC = 6,
  GOTO_STEP = 7,
  TICKET = 8,
}
export enum ENUM_TICKETS_STATO {
  Segnalato = 1,
  Aperto = 2,
  Pianificato = 3,
  Trasferito = 4,
  Assegnato = 5,
  Lavorazione = 6,
  Sospeso = 7,
  Respinto = 8,
  Chiuso = 9,
  FeedBack = 10,
}
export enum ENUM_PROGRESSIVI_CHIAVE {
  TICKETS = 'TIK',
  ARTICOLI = 'ART',
}
export enum ENUM_PROGRESSIVI_ZeroPad {
  DEFAULT = '00000000',
}
export enum ENUM_PROGRESSIVI_SCHEMA {
  NUMERO = 'NUM',
  ART_SUBCATEG = 'CAS',
  ART_CATEGORIA = 'CAT',
  TIK_TIPO = 'TIT',
}
export enum ENUM_CHECKS_RICHIESTA_FIRMA {
  NonRichiesta = 1,
  RichiestaSingola = 2,
  RichiestaDoppia = 3,

}
export enum FUNZIONE_SYSTEM {
  MODULO = 'SYSTEM',
  _10_impostazioni = 'SYSTEM10',
  _11_imp_avanzate = 'SYSTEM11',
  _20_utenti = 'SYSTEM20',
}
export enum FUNZIONE_DATADB {
  MODULO = 'DATADB',
  _10_accesso = 'DATADB10',
}
export enum FUNZIONE_CHECKS {
  MODULO = 'CHECKS',
  _10_accesso = 'CHECKS10',
}
export enum FUNZIONE_TICKET {
  MODULO = 'TICKET',
  _10_accesso = 'TICKET10',
  _20_gestione = 'TICKET20',
  _21_L_solo_tickets_utente = 'TICKET21',
  _22_L_new_tik_richiede_approvazione = 'TICKET22',
  _23_O_cambio_data = 'TICKET23',
  _24_O_pianificazione = 'TICKET24',
}
export enum FUNZIONE_MAGART {
  MODULO = 'MAGART',
  _10_accesso = 'MAGART10',
  _11_mov_scarico = 'MAGART11',
  _12_mov_carico = 'MAGART12',
  _20_struttura_magazzino = 'MAGART20',
}
// SysImpostazioniUtente
enum GRUPPO {
  FILTRO = 'FILTRO',
  GLOBALE = 'GLOBALE',
}
enum TYPE {
  text = 'text',
  number = 'number',
  password = 'password',
  json = 'json',
}
enum CHIAVE {
  VisDis_Divisioni = 'VisDis_Divisioni',
  VisDis_Aree = 'VisDis_Aree',
  VisDis_Reparti = 'VisDis_Reparti',
  VisDis_Postazioni = 'VisDis_Postazioni',
  VisDis_Macchine = 'VisDis_Macchine',
  VisDis_MacchineComponenti = 'VisDis_MacchineComponenti',
  VisDis_Persone = 'VisDis_Persone',
  VisDis_Procedure = 'VisDis_Procedure',
  VisDis_TicketAllerta = 'VisDis_TicketAllerta',
  VisDis_TicketStato = 'VisDis_TicketStato',
  VisDis_Magazzini = 'VisDis_Magazzini',
  VisDis_Articoli = 'VisDis_Articoli',
  VisArc_ListaTicket = 'VisArc_ListaTicket',
  VisPia_ListaTicket = 'VisPia_ListaTicket',
  SideNav_Collapsed = 'SideNav_Collapsed',
  Tickets_JsonMyTicketsWeb = 'Tickets_JsonMyTicketsWeb',
  Tickets_JsonCalendarWeb = 'Tickets_JsonCalendarWeb',
}
export const ENUM_SYSIMPOSTAUTENTE = {
  TYPE,
  GRUPPO,
  CHIAVE,
};
export enum ENUM_MODULI {
  TICKET = 'TICKET',
  CHECKS = 'CHECKS',
  DATADB = 'DATADB',
  SYSTEM = 'SYSTEM',
  MAGART = 'MAGART',
}

export enum ENUM_EXPLORER_VISUALIZZA {
  ICO_LG = 'ICO_LG',
  ICO_MD = 'ICO_MD',
  ICO_SM = 'ICO_SM',
  LIST = 'LIST',
  CONTENT = 'CONTENT',
}
export enum ENUM_FILE_DATA_TYPES_BASE64_PREFIX {
  PNG = 'data:image/png;base64,',
  JPEG = 'data:image/jpeg;base64,',
  BMP = 'data:image/bmp;base64,',
  GIF = 'data:image/gif;base64,',
  PDF = 'application/pdf',
  JSON = 'application/json',
}
export enum ENUM_FILE_MIME_TYPE {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  BMP = 'image/bmp,',
  GIF = 'image/gif',
  PDF = 'application/pdf',
  JSON = 'application/json',
}
export enum ENUM_FILE_EXTENSION {
  PNG = 'png',
  JPEG = 'jpeg',
  BMP = 'bmp,',
  GIF = 'gif',
  PDF = 'pdf',
  JSON = 'json',
}
export enum ENUM_FILE_MEDIA_TYPE {
  PNG = 'image',
  JPEG = 'image',
  BMP = 'image',
  GIF = 'image',
  PDF = 'application',
  JSON = 'application',
}
export enum ENUM_NOTIFICHE_TOKEN_PIATTAFORMA {
  BROWSER = 'BROWSER',
  MOBILE = 'MOBILE',
}
export enum ENUM_ACTIONS {
  ADD = 'add',
  DELETE = 'del',
  UPDATE = 'upd',
  BACK = 'bak',
}
